import type { FaireProductEntity } from "../../entity_types/product";

export const p_kjdy63mmat: FaireProductEntity = {
  token: "p_kjdy63mmat",
  type: "product",
  name: "Sourdough Harvest Table Runner",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/2f8cee3016bd219c3c54600d93edf73fca62360b5059adea816529da310aaf53.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ef0a183fa2b734bbf16ef359d91c0f25b61443fdfd9f0c240b3b6e85c7045436.jpeg"
  ],
  priceDollars: 26,
  description: "Table Runner \n\nThe Geometry Table Runner adds a quiet touch of beauty to any gathering—layered, minimal, or styled your way. Available in three versatile lengths, it’s designed to bring a polished look without feeling overdone. Made from 100% post-consumer recycled materials, it resists spills and washes with ease. Everyday-ready. Occasion-worthy.\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * Available in 16” x 60”, 16” x 90”, and 16” x 120” \n * Lightweight with a soft, structured drape \n * Stain-resistant and machine washable \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\nGather with grace. Tread with care.\n\nWhether it’s styled solo or topped with candles and conversation, the Table Runner sets the tone for meaningful connection. Every piece is thoughtfully crafted using materials that would’ve ended up in landfills, giving waste a second life. Minimal impact, maximum beauty.\n\nAdd elegance to your table. Discover the Geometry Table Runner.\n\n\n",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:43.676Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
